import React from 'react';
import { List, X } from 'phosphor-react';

const FloatingHamburgerButton = ({
  isOpen = false,
  onClick,
  className = '',
  openLabel = 'Open question navigation',
  closeLabel = 'Close question navigation',
}) => {
  return (
    <button
      type="button"
      className={`fixed bottom-[142px] max-md:bottom-[129px] right-6 w-[44px] h-[44px] rounded-full bg-[#258C8E] text-white cursor-pointer z-[1000] flex items-center justify-center transition-all duration-200 active:scale-95 hover:bg-[#2a9a9c] xl:hidden ${className}`}
      onClick={onClick}
      aria-label={isOpen ? closeLabel : openLabel}
      aria-expanded={isOpen}
    >
      {isOpen ? <X size={18} weight="bold" color="#FFFFFF" /> : <List size={18} weight="bold" color="#FFFFFF" />}
    </button>
  );
};

export default FloatingHamburgerButton;
